const LetterBox = ({ letter }) => {
	return <p className={`LetterBox ${letter.state}`}>{letter.letter}</p>
};

export default LetterBox;
